import {
  asStr,
  buildDadosPrincipais,
  buildObservacoes,
  buildPhases,
  statusLabel,
  statusTone,
  type CardSlot,
  type CardFieldMap,
  type DetailFieldMap,
  type PipeSpec,
} from '@/modules/kanban';

// ─── Selects compartilhados ────────────────────────────────────────────
const TIPO_PROPRIEDADE = [
  { value: 'proprio', label: 'Próprio' },
  { value: 'arrendado', label: 'Arrendado' },
  { value: 'posse', label: 'Posse' },
];
const STATUS_SICAR = [
  { value: 'analise', label: 'Em análise' },
  { value: 'pendente', label: 'Pendente' },
  { value: 'ativo', label: 'Ativo' },
  { value: 'suspenso', label: 'Suspenso' },
  { value: 'cancelado', label: 'Cancelado' },
];
const STATUS_RETIFICACAO = [
  { value: 'sem_retificacao', label: 'Sem retificação' },
  { value: 'solicitada', label: 'Solicitada' },
  { value: 'em_andamento', label: 'Em andamento' },
  { value: 'enviada', label: 'Enviada' },
  { value: 'finalizada', label: 'Finalizada' },
];
const MOTIVO_CANCELAMENTO_CAR = [
  { value: 'unificacao', label: 'Unificação de imóveis rurais conforme IN nº 02/MMA de 5 de maio de 2014.' },
  { value: 'correcao_municipio', label: 'Correção de município conforme documentação do imóvel.' },
  { value: 'determinacao_judicial', label: 'Determinação judicial.' },
  { value: 'outro', label: 'Outro.' },
];
const SIM_NAO = [
  { value: 'sim', label: 'Sim' },
  { value: 'nao', label: 'Não' },
];
const PRADA_SOLO_TIPO = [
  { value: 'argiloso', label: 'Argiloso' },
  { value: 'arenoso', label: 'Arenoso' },
  { value: 'pedregoso', label: 'Pedregoso' },
];
const PRADA_APP_DATA_DEGRADACAO = [
  { value: 'antes_2008', label: 'Antes de 22/07/2008' },
  { value: 'apos_2008', label: 'Após 22/07/2008' },
  { value: 'antes_e_apos_2008', label: 'Antes e após 22/07/2008' },
];
const PRADA_APP_QUALIDADE_AGUA = [
  { value: 'transparente', label: 'Transparente' },
  { value: 'turva', label: 'Turva' },
  { value: 'com_odor', label: 'Com odor' },
];
const PRADA_APP_FLUXO_AGUA = [
  { value: 'efemero', label: 'Efêmero' },
  { value: 'perene', label: 'Perene' },
  { value: 'intermitente', label: 'Intermitente' },
];
const SIM_NAO_NAO_HA_ATIVIDADE = [
  { value: 'sim', label: 'Sim' },
  { value: 'nao', label: 'Não' },
  { value: 'nao_ha_atividade', label: 'Não há atividade no imóvel' },
];
const STATUS_FINAL_CAR = [
  { value: 'aguardando_analise', label: 'Aguardando análise' },
  { value: 'aprovado_com_pendencia', label: 'Aprovado com pendência' },
  { value: 'aprovado_sem_pendencia', label: 'Aprovado sem pendência' },
];
const MOTIVO_PRIORIDADE_CAR = [
  { value: 'imovel_em_unidade_de_conservacao', label: 'Imóvel em Unidade de Conservação' },
  { value: 'area_embargada', label: 'Área embargada' },
  { value: 'acao_judicial_recuperacao_ambiental', label: 'Ação judicial de recuperação ambiental' },
  { value: 'termo_de_compromisso_ou_similar', label: 'Termo de compromisso ou similar' },
  { value: 'impedimento_de_financiamento_por_passivo_ambiental', label: 'Impedimento de financiamento por passivo ambiental' },
];
const TIPO_AJUSTE_RETIFICACAO = [
  { value: 'documental', label: 'Documental' },
  { value: 'geoespacial', label: 'Geoespacial' },
  { value: 'cadastro', label: 'Cadastro' },
  { value: 'rl_app', label: 'RL / APP' },
  { value: 'sobreposicao', label: 'Sobreposição' },
  { value: 'prazos', label: 'Prazos' },
  { value: 'outro', label: 'Outro' },
];
const RESULTADO_RETIFICACAO = [
  { value: 'aguardando_analise', label: 'Aguardando análise' },
  { value: 'nova_notificacao', label: 'Nova notificação' },
  { value: 'aprovado_com_pendencia', label: 'Aprovado com pendência' },
  { value: 'aprovado_sem_pendencia', label: 'Aprovado sem pendência' },
];
const MODALIDADE_PRA = [
  { value: 'prada', label: 'PRADA' },
  { value: 'rl_equivalente', label: 'RL equivalente' },
  { value: 'servidao', label: 'Servidão' },
  { value: 'doacao', label: 'Doação ao Poder Público' },
];
const SERVICO_TIPO = [
  { value: 'ambiental_car', label: 'CAR' },
  { value: 'ambiental_pra', label: 'PRA' },
  { value: 'ambiental_desembargo', label: 'Desembargo' },
  { value: 'ambiental_limpeza', label: 'Limpeza de pastagem' },
  { value: 'ambiental_licenciamento', label: 'Licenciamento de Empreendimentos' },
  { value: 'ambiental_estudos_tecnicos', label: 'Laudos e Análises Técnicas' },
];
const LICENCIAMENTO_ETAPA = [
  { value: 'LP', label: 'LP' },
  { value: 'LI', label: 'LI' },
  { value: 'LO', label: 'LO' },
];
const ESTUDO_TECNICO_TIPO = [
  { value: 'laudo_parecer', label: 'Laudo / Parecer técnico' },
  { value: 'analise_multitemporal', label: 'Análise geoespacial multitemporal' },
];
const STATUS_NEGOCIACAO = [
  { value: 'triagem', label: 'Triagem' },
  { value: 'negociacao', label: 'Negociação' },
  { value: 'aceito', label: 'Aceito' },
  { value: 'novo_orcamento', label: 'Novo orçamento' },
  { value: 'nao_contratado', label: 'Não contratado' },
];

function findLabel(options: Array<{ value: string; label: string }>, value: unknown) {
  const raw = String(value || '').trim();
  if (!raw) return null;
  return options.find((item) => item.value === raw)?.label || raw;
}

function buildCarFormularioFields(card: Record<string, unknown>): ReturnType<DetailFieldMap> {
  return [
    {
      section: 'Formulários CAR',
      label: 'Novo e-mail no SICAR',
      value: asStr(card.car_alteracao_email_novo_email) ?? '—',
      alwaysShow: true,
      field: 'car_alteracao_email_novo_email',
      type: 'text',
      rawValue: asStr(card.car_alteracao_email_novo_email),
      helpText:
        'Informe o novo e-mail que deverá substituir o cadastrado hoje no SICAR.',
    },
    {
      section: 'Formulários CAR',
      label: 'Outro vínculo do requerente',
      value: asStr(card.car_alteracao_email_outro_vinculo) ?? '—',
      alwaysShow: true,
      field: 'car_alteracao_email_outro_vinculo',
      type: 'text',
      rawValue: asStr(card.car_alteracao_email_outro_vinculo),
      helpText:
        'Use quando o requerente não for proprietário nem possuidor no formulário de alteração de e-mail.',
    },
    {
      section: 'Formulários CAR',
      label: 'Requerimento de alteração de e-mail no SICAR',
      value: 'Emitir formulário',
      alwaysShow: true,
      type: 'emitir_formulario_alteracao_email_sicar',
    },
    {
      section: 'Formulários CAR',
      label: 'Motivo do cancelamento do CAR',
      value: findLabel(MOTIVO_CANCELAMENTO_CAR, card.car_cancelamento_motivo) ?? '—',
      alwaysShow: true,
      field: 'car_cancelamento_motivo',
      type: 'select',
      rawValue: asStr(card.car_cancelamento_motivo),
      options: MOTIVO_CANCELAMENTO_CAR,
      helpText:
        'Escolha a justificativa que será marcada no requerimento oficial de cancelamento do CAR.',
    },
    {
      section: 'Formulários CAR',
      label: 'Outro motivo do cancelamento',
      value: asStr(card.car_cancelamento_outro_motivo) ?? '—',
      alwaysShow: true,
      field: 'car_cancelamento_outro_motivo',
      type: 'text',
      rawValue: asStr(card.car_cancelamento_outro_motivo),
      helpText:
        'Preencha somente quando a opção escolhida em "Motivo do cancelamento do CAR" for "Outro".',
    },
    {
      section: 'Formulários CAR',
      label: 'Imóvel rural para unificação',
      value: asStr(card.car_cancelamento_imovel_unificacao) ?? '—',
      alwaysShow: true,
      field: 'car_cancelamento_imovel_unificacao',
      type: 'text',
      rawValue: asStr(card.car_cancelamento_imovel_unificacao),
    },
    {
      section: 'Formulários CAR',
      label: 'Número de recibo da unificação',
      value: asStr(card.car_cancelamento_recibo_unificacao) ?? '—',
      alwaysShow: true,
      field: 'car_cancelamento_recibo_unificacao',
      type: 'text',
      rawValue: asStr(card.car_cancelamento_recibo_unificacao),
    },
    {
      section: 'Formulários CAR',
      label: 'Outro vínculo do requerente',
      value: asStr(card.car_cancelamento_outro_vinculo) ?? '—',
      alwaysShow: true,
      field: 'car_cancelamento_outro_vinculo',
      type: 'text',
      rawValue: asStr(card.car_cancelamento_outro_vinculo),
      helpText:
        'Use quando o requerente não for proprietário nem possuidor no formulário de cancelamento.',
    },
    {
      section: 'Formulários CAR',
      label: 'Requerimento de cancelamento de CAR',
      value: 'Emitir formulário',
      alwaysShow: true,
      type: 'emitir_formulario_cancelamento_car',
    },
  ];
}

function isCarEntrada(card: Record<string, unknown>) {
  return String(card.tipo_processo || '').trim() === 'ambiental_car'
    && Number(card.kanban_coluna) === 40;
}

function normalizeText(value: unknown) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

function resolveServicoLabel(card: Record<string, unknown>) {
  const servico = String(card.servico_tipo || card.tipo_processo || '').trim();
  if (!servico) return null;
  if (servico === 'ambiental_licenciamento') {
    const etapa = findLabel(LICENCIAMENTO_ETAPA, card.licenciamento_etapa);
    return etapa ? `Licenciamento de Empreendimentos • ${etapa}` : 'Licenciamento de Empreendimentos';
  }
  if (servico === 'ambiental_estudos_tecnicos') {
    const estudo = findLabel(ESTUDO_TECNICO_TIPO, card.estudo_tecnico_tipo);
    return estudo ? `Laudos e Análises Técnicas • ${estudo}` : 'Laudos e Análises Técnicas';
  }
  if (servico === 'ambiental_laudo_parecer') return 'Laudo / Parecer técnico';
  if (servico === 'ambiental_analise_multitemporal') return 'Análise geoespacial multitemporal';
  if (servico === 'ambiental_lp') return 'Licença Prévia (LP)';
  if (servico === 'ambiental_li') return 'Licença de Instalação (LI)';
  if (servico === 'ambiental_lo') return 'Licença de Operação (LO)';
  return findLabel(SERVICO_TIPO, servico);
}

function findPhaseName(card: Record<string, unknown>) {
  const pipe = pickPipe(card);
  if (!pipe) return null;
  const colNum = Number(card.kanban_coluna) || 0;
  const ordemNum = Number(card.kanban_ordem) || 0;
  const phaseIndex = ordemNum || (colNum - pipe.colStart + 1);
  return pipe.phases[phaseIndex - 1]?.name || null;
}

function resolveImovelLabel(card: Record<string, unknown>) {
  const denominacao = String(card.imovel_denominacao || '').trim();
  if (denominacao) return denominacao;
  const matricula = String(card.imovel_matricula || '').trim();
  if (matricula) return `Matricula ${matricula}`;
  const imovelId = String(card.imovel_id || '').trim();
  if (imovelId) return `Imovel ID ${imovelId}`;
  return null;
}

function resolveCarSubtitle(card: Record<string, unknown>) {
  const codigoCar = String(card.codigo_car || '').trim();
  if (codigoCar) return `CAR: ${codigoCar}`;
  const protocolo = String(card.numero_protocolo || '').trim();
  if (protocolo) return `Protocolo SICAR: ${protocolo}`;
  return 'CAR: nao inscrito';
}

function buildCarMeta(card: Record<string, unknown>) {
  return [resolveImovelLabel(card), String(card.municipio || '').trim()]
    .filter(Boolean)
    .join(' - ') || null;
}

function buildCarChips(card: Record<string, unknown>): CardSlot[] {
  const chips: CardSlot[] = [];
  const phaseName = findPhaseName(card);
  const phaseSlug = normalizeText(phaseName);
  const statusRaw = String(card.status || '').trim();
  const statusSicar = findLabel(STATUS_SICAR, card.status_sicar);
  const qtdRetificacoes = Number(card.qtd_retificacoes || 0);
  const retificacaoAberta = String(card.possui_retificacao_aberta || '').trim() === 'sim';
  const prioridade = String(card.pedido_analise_prioritaria || '').trim() === 'sim';
  const ultimoNumeroNotificacao = String(card.ultimo_numero_notificacao || '').trim();
  const statusFinalCar = String(card.status_final_analise_car || '').trim();
  const hasEmbargo =
    String(card.termo_embargo_numero || '').trim() !== '' ||
    Number(card.area_embargada_ha || 0) > 0 ||
    String(card.motivo_analise_prioritaria || '').trim() === 'area_embargada';

  if (phaseName) {
    const tone =
      phaseSlug === 'pendente de retificacao' ? 'warn'
      : phaseSlug === 'aprovado com pendencia' ? 'warn'
      : phaseSlug === 'aprovado sem pendencia' ? 'ok'
      : 'info';
    chips.push({ label: 'Fase', value: phaseName, tone });
  }
  if (statusRaw) {
    chips.push({ label: 'Status', value: statusLabel(statusRaw), tone: statusTone(statusRaw) });
  }
  if (statusSicar) {
    chips.push({ label: 'SICAR', value: statusSicar, tone: 'neutral' });
  }
  if (qtdRetificacoes > 0) {
    chips.push({
      label: 'Retificacoes',
      value: `${qtdRetificacoes} ${qtdRetificacoes === 1 ? 'retificacao' : 'retificacoes'}`,
      tone: 'warn',
    });
  }
  if (retificacaoAberta) {
    chips.push({ label: 'Retificacao', value: 'Aberta', tone: 'warn' });
  }
  if (ultimoNumeroNotificacao && (phaseSlug === 'pendente de retificacao' || retificacaoAberta)) {
    chips.push({ label: 'Notif.', value: ultimoNumeroNotificacao, tone: 'warn' });
  }
  if (prioridade) {
    chips.push({ label: 'Prioridade', value: 'Prioritario', tone: 'danger' });
  }
  if (hasEmbargo) {
    chips.push({ label: 'Embargo', value: 'Embargo', tone: 'danger' });
  }
  if (statusFinalCar === 'aprovado_com_pendencia') {
    chips.push({ label: 'Resultado', value: 'Com pendencia', tone: 'warn' });
  }
  return chips;
}

function buildCarRetificacaoChildChips(card: Record<string, unknown>): CardSlot[] {
  const chips: CardSlot[] = [];
  const phaseName = findPhaseName(card);
  const statusRaw = String(card.status || '').trim();
  const rodadaRetificacao = Number(card.rodada_retificacao || 0) || 1;
  const numeroNotificacao = String(card.numero_notificacao || '').trim();
  const tipoAjuste = findLabel(TIPO_AJUSTE_RETIFICACAO, card.tipo_ajuste);
  const resultado = findLabel(RESULTADO_RETIFICACAO, card.resultado_apos_analise);

  chips.push({ label: 'Rodada', value: `Retificacao #${rodadaRetificacao}`, tone: 'warn' });
  if (phaseName) chips.push({ label: 'Fase', value: phaseName, tone: 'info' });
  if (statusRaw) chips.push({ label: 'Status', value: statusLabel(statusRaw), tone: statusTone(statusRaw) });
  if (numeroNotificacao) chips.push({ label: 'Notif.', value: numeroNotificacao, tone: 'warn' });
  if (tipoAjuste) chips.push({ label: 'Ajuste', value: tipoAjuste, tone: 'accent' });
  if (resultado && String(card.resultado_apos_analise || '').trim() !== 'aguardando_analise') {
    chips.push({ label: 'Resultado', value: resultado, tone: 'ok' });
  }
  return chips;
}

// ─── Pipes ─────────────────────────────────────────────────────────────
const PIPE_PRA: PipeSpec = {
  colStart: 30,
  phases: [
    {
      name: 'Entrada',
      fields: [
        { key: 'municipio', label: 'Município', type: 'text' },
        { key: 'area_estimada_ha', label: 'Área estimada (ha)', type: 'number' },
        { key: 'tipo_propriedade', label: 'Tipo de propriedade', type: 'select', options: TIPO_PROPRIEDADE },
        { key: 'data_entrada', label: 'Data de entrada', type: 'date' },
        {
          key: 'pra_reside_imovel',
          label: 'Reside no imóvel rural?',
          type: 'select',
          options: SIM_NAO,
          helpText: 'Preenche o item 1.11 do modelo oficial do PRA.',
        },
        {
          key: 'pra_atividade_agricultura',
          label: 'Atividade no imóvel: Agricultura',
          type: 'boolean',
          helpText: 'Marque todas as atividades aplicáveis no item 1.12.',
        },
        { key: 'pra_atividade_artesanato', label: 'Atividade no imóvel: Artesanato', type: 'boolean' },
        {
          key: 'pra_atividade_beneficiamento',
          label: 'Atividade no imóvel: Beneficiamento',
          type: 'boolean',
        },
        {
          key: 'pra_atividade_criacao_animais',
          label: 'Atividade no imóvel: Criação de animais',
          type: 'boolean',
        },
        { key: 'pra_atividade_extrativismo', label: 'Atividade no imóvel: Extrativismo', type: 'boolean' },
        { key: 'pra_atividade_silvicultura', label: 'Atividade no imóvel: Silvicultura', type: 'boolean' },
        { key: 'pra_atividade_piscicultura', label: 'Atividade no imóvel: Piscicultura', type: 'boolean' },
        {
          key: 'pra_atividade_nenhuma',
          label: 'Atividade no imóvel: Nenhuma atividade',
          type: 'boolean',
        },
        { key: 'pra_atividade_outras', label: 'Atividade no imóvel: Outras', type: 'text' },
        {
          key: 'pra_mao_obra_familiar',
          label: 'Mão-de-obra predominantemente familiar?',
          type: 'select',
          options: SIM_NAO_NAO_HA_ATIVIDADE,
          helpText: 'Preenche o item 1.13 do requerimento.',
        },
        {
          key: 'pra_renda_familiar_imovel',
          label: 'Renda familiar vem predominantemente do imóvel?',
          type: 'select',
          options: SIM_NAO_NAO_HA_ATIVIDADE,
          helpText: 'Preenche o item 1.14 do requerimento.',
        },
        {
          key: 'pra_apoio_tecnico_sedam',
          label: 'Deseja apoio técnico da SEDAM para o PRADA?',
          type: 'select',
          options: SIM_NAO,
          helpText: 'Preenche o item 1.15 do modelo oficial.',
        },
        {
          key: 'pra_alteracao_area_apos_2008',
          label: 'Houve alteração da área após 22/07/2008?',
          type: 'select',
          options: SIM_NAO,
        },
        {
          key: 'pra_possui_tac',
          label: 'Existe TAC aprovado para regularização ambiental?',
          type: 'select',
          options: SIM_NAO,
        },
        {
          key: 'pra_possui_prad',
          label: 'Existe PRAD aprovado?',
          type: 'select',
          options: SIM_NAO,
        },
        {
          key: 'pra_possui_infracao_autuada',
          label: 'Existem infrações autuadas até 22/07/2008?',
          type: 'select',
          options: SIM_NAO,
          helpText: 'Se marcar sim, preencha também os dados da infração logo abaixo.',
        },
        {
          key: 'processo_administrativo',
          label: 'Infração PRA: Nº do processo administrativo',
          type: 'text',
          showIf: (c) => String(c.pra_possui_infracao_autuada || '').trim() === 'sim',
        },
        {
          key: 'auto_infracao_numero',
          label: 'Infração PRA: Nº do auto de infração',
          type: 'text',
          showIf: (c) => String(c.pra_possui_infracao_autuada || '').trim() === 'sim',
        },
        {
          key: 'orgao_autuacao',
          label: 'Infração PRA: Órgão autuador',
          type: 'text',
          showIf: (c) => String(c.pra_possui_infracao_autuada || '').trim() === 'sim',
        },
        {
          key: 'data_infracao',
          label: 'Infração PRA: Data da infração',
          type: 'date',
          showIf: (c) => String(c.pra_possui_infracao_autuada || '').trim() === 'sim',
        },
        { key: 'formulario_pra', label: 'Requerimento de adesão ao PRA', type: 'emitir_formulario_pra', editable: false },
      ],
    },
    {
      name: 'Documentação',
      // pendencias_documentacao / data_documentacao_completa não existem
      // em processo_ambiental_dados — sem campos editáveis aqui.
      fields: [],
    },
    {
      name: 'Definição da modalidade',
      fields: [
        { key: 'modalidade_pra', label: 'Modalidade', type: 'select', options: MODALIDADE_PRA },
      ],
    },
    {
      name: 'Projeto técnico / PRADA',
      fields: [
        {
          key: 'prada_simplificado_apto',
          label: 'Imóvel apto ao PRADA simplificado?',
          type: 'select',
          options: SIM_NAO,
          helpText: 'Marque "sim" somente quando o imóvel puder usar o modelo simplificado. Quando for "não", o botão de emissão fica bloqueado.',
        },
        {
          key: 'prada_simplificado_observacao',
          label: 'Observação sobre enquadramento no simplificado',
          type: 'textarea',
          helpText: 'Use este campo para justificar por que o imóvel não se enquadra, ou registrar ressalvas técnicas do modelo simplificado.',
        },
        {
          key: 'prada_responsavel_tecnico_nome',
          label: 'Resp. técnico: nome',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_responsavel_tecnico_profissao',
          label: 'Resp. técnico: profissão',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_responsavel_tecnico_registro',
          label: 'Resp. técnico: registro no conselho',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_responsavel_tecnico_endereco',
          label: 'Resp. técnico: endereço',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_responsavel_tecnico_numero',
          label: 'Resp. técnico: número',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_responsavel_tecnico_municipio',
          label: 'Resp. técnico: município',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_responsavel_tecnico_uf',
          label: 'Resp. técnico: UF',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_responsavel_tecnico_cep',
          label: 'Resp. técnico: CEP',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_responsavel_tecnico_email',
          label: 'Resp. técnico: e-mail',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_responsavel_tecnico_telefone',
          label: 'Resp. técnico: telefone',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_art_elaboracao_numero',
          label: 'ART elaboração: número',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_art_elaboracao_validade',
          label: 'ART elaboração: validade',
          type: 'date',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_art_execucao_numero',
          label: 'ART execução: número',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_art_execucao_validade',
          label: 'ART execução: validade',
          type: 'date',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_porteira_latitude',
          label: 'Porteira de acesso: latitude',
          type: 'text',
          helpText: 'Preencha só se houver coordenada confirmada da porteira/entrada do imóvel.',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_porteira_longitude',
          label: 'Porteira de acesso: longitude',
          type: 'text',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_area_reserva_legal_ha',
          label: 'Área RL a recuperar (ha)',
          type: 'number',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_area_app_ha',
          label: 'Área APP a recuperar (ha)',
          type: 'number',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        {
          key: 'prada_area_uso_restrito_ha',
          label: 'Área de uso restrito a recuperar (ha)',
          type: 'number',
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        { key: 'prada_causa_pecuaria', label: 'Causa da degradação: Pecuária', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_causa_agricultura', label: 'Causa da degradação: Agricultura', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_causa_piscicultura', label: 'Causa da degradação: Piscicultura', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_causa_mineracao', label: 'Causa da degradação: Mineração', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_causa_obras_civis', label: 'Causa da degradação: Obras civis', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_causa_queimadas', label: 'Causa da degradação: Queimadas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_causa_outros', label: 'Causa da degradação: Outros', type: 'text', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_impacto_desmatamento_rl', label: 'Impacto: Desmatamento em RL', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_impacto_desmatamento_app', label: 'Impacto: Desmatamento em APP', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_impacto_desmatamento_ur', label: 'Impacto: Desmatamento em uso restrito', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_impacto_degradacao_florestal', label: 'Impacto: Degradação florestal', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_impacto_alteracao_hidricos', label: 'Impacto: Alteração de recursos hídricos', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_impacto_alteracao_solo', label: 'Impacto: Alteração na estrutura do solo', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_efeito_perda_biodiversidade', label: 'Efeito: Perda de biodiversidade', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_efeito_alteracao_agua', label: 'Efeito: Alteração da disponibilidade/qualidade da água', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_efeito_assoreamento', label: 'Efeito: Assoreamento de curso d’água', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_efeito_erosao', label: 'Efeito: Aparecimento de processos erosivos', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_atividade_info', label: 'Atividade principal e informações importantes', type: 'textarea', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        {
          key: 'prada_solo_tipo',
          label: 'Solo predominante',
          type: 'select',
          options: PRADA_SOLO_TIPO,
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
        { key: 'prada_solo_classificacao', label: 'Classificação do solo', type: 'text', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_solo_ha_erosao', label: 'Há processos erosivos?', type: 'select', options: SIM_NAO, showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_solo_metodologia_erosao', label: 'Metodologia para conter erosão', type: 'textarea', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_nao_se_aplica', label: 'APP a recuperar: Não se aplica', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_data_degradacao', label: 'APP: data da degradação', type: 'select', options: PRADA_APP_DATA_DEGRADACAO, showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_qualidade_agua', label: 'APP: qualidade da água', type: 'select', options: PRADA_APP_QUALIDADE_AGUA, showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_fluxo_agua', label: 'APP: regularidade do fluxo de água', type: 'select', options: PRADA_APP_FLUXO_AGUA, showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_biodiversidade_com_fauna', label: 'APP biodiversidade: Com fauna', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_biodiversidade_sem_fauna', label: 'APP biodiversidade: Sem fauna', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_biodiversidade_com_flora', label: 'APP biodiversidade: Com flora', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_biodiversidade_sem_flora', label: 'APP biodiversidade: Sem flora', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_leito_com_erosoes', label: 'APP leito/margens: Com erosões', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_leito_assoreada', label: 'APP leito/margens: Assoreada', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_leito_com_vegetacao', label: 'APP leito/margens: Com vegetação', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_leito_sem_vegetacao', label: 'APP leito/margens: Sem vegetação', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_uso_agricultura', label: 'APP entorno: Agricultura', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_uso_pastagem', label: 'APP entorno: Pastagem', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_uso_mineracao', label: 'APP entorno: Mineração', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_uso_outro', label: 'APP entorno: Outro', type: 'text', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_metodologia_isolamento', label: 'APP metodologia: Isolamento', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_metodologia_retirada', label: 'APP metodologia: Retirada dos fatores de degradação', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_metodologia_regeneracao', label: 'APP metodologia: Regeneração natural', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_metodologia_enriquecimento', label: 'APP metodologia: Enriquecimento com espécies nativas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_metodologia_plantio_100_nativas', label: 'APP metodologia: Plantio 100% nativas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_metodologia_plantio_intercalado', label: 'APP metodologia: Plantio intercalado de nativas e exóticas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_metodologia_semeadura_direta', label: 'APP metodologia: Semeadura direta', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_metodologia_sistema_agroflorestal', label: 'APP metodologia: Sistema Agroflorestal', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_app_metodologia_outro', label: 'APP metodologia: Outro', type: 'text', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_reserva_legal', label: 'ARL/UR: marcar Reserva Legal', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_uso_restrito', label: 'ARL/UR: marcar Uso restrito', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_nao_se_aplica', label: 'ARL/UR: Não se aplica', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_biodiversidade_com_fauna', label: 'ARL/UR biodiversidade: Com fauna', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_biodiversidade_sem_fauna', label: 'ARL/UR biodiversidade: Sem fauna', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_biodiversidade_com_flora', label: 'ARL/UR biodiversidade: Com flora', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_biodiversidade_sem_flora', label: 'ARL/UR biodiversidade: Sem flora', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_uso_agricultura', label: 'ARL/UR entorno: Agricultura', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_uso_pastagem', label: 'ARL/UR entorno: Pastagem', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_uso_mineracao', label: 'ARL/UR entorno: Mineração', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_uso_outro', label: 'ARL/UR entorno: Outro', type: 'text', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_metodologia_isolamento', label: 'ARL/UR metodologia: Isolamento', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_metodologia_retirada', label: 'ARL/UR metodologia: Retirada dos fatores de degradação', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_metodologia_regeneracao', label: 'ARL/UR metodologia: Regeneração natural', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_metodologia_enriquecimento', label: 'ARL/UR metodologia: Enriquecimento com espécies nativas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_metodologia_plantio_100_nativas', label: 'ARL/UR metodologia: Plantio 100% nativas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_metodologia_plantio_intercalado', label: 'ARL/UR metodologia: Plantio intercalado de nativas e exóticas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_metodologia_semeadura_direta', label: 'ARL/UR metodologia: Semeadura direta', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_metodologia_sistema_agroflorestal', label: 'ARL/UR metodologia: Sistema Agroflorestal', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_arl_metodologia_outro', label: 'ARL/UR metodologia: Outro', type: 'text', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_sementes', label: 'Insumos: Sementes', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_mudas', label: 'Insumos: Mudas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_adubo_organico', label: 'Insumos: Adubo orgânico', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_adubo_quimico', label: 'Insumos: Adubo químico', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_formicidas', label: 'Insumos: Formicidas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_biopesticidas', label: 'Insumos: Biopesticidas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_herbicidas', label: 'Insumos: Herbicidas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_calcario', label: 'Insumos: Calcário', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_estacas', label: 'Insumos: Estacas', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_mouroes', label: 'Insumos: Mourões', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_arame', label: 'Insumos: Arame', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_insumo_outro', label: 'Insumos: Outro', type: 'text', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_plantio_preparo_manual', label: 'Plantio: Preparo manual do solo', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_plantio_preparo_mecanizado', label: 'Plantio: Preparo mecanizado do solo', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_plantio_manual', label: 'Plantio: Plantio manual', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_plantio_mecanizado', label: 'Plantio: Plantio mecanizado', type: 'boolean', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_plantio_descricao', label: 'Plantio: descrição simplificada', type: 'textarea', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'prada_outras_recomendacoes', label: 'Outras recomendações técnicas', type: 'textarea', showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim' },
        { key: 'art_numero', label: 'Nº ART', type: 'text' },
        { key: 'art_valor', label: 'Valor ART (R$)', type: 'number' },
        {
          key: 'prada_simplificado_apto',
          label: 'PRADA simplificado oficial',
          type: 'emitir_prada_simplificado',
          editable: false,
          showIf: (c) => String(c.prada_simplificado_apto || '').trim() === 'sim',
        },
      ],
    },
    {
      name: 'Protocolo SEDAM',
      fields: [
        { key: 'numero_protocolo', label: 'Nº protocolo', type: 'text' },
        { key: 'data_protocolo', label: 'Data protocolo', type: 'date' },
        { key: 'orgao_competente', label: 'Órgão competente', type: 'text' },
      ],
    },
    {
      name: 'Análise SEDAM',
      fields: [
        { key: 'observacoes', label: 'Observações da análise', type: 'textarea' },
      ],
    },
    {
      name: 'Termo de compromisso',
      // numero_averbacao / data_averbacao não existem em processo_ambiental_dados.
      fields: [],
    },
    {
      name: 'Concluído',
      fields: [
        { key: 'observacoes_finais', label: 'Observações finais', type: 'textarea' },
      ],
    },
  ],
};

const PIPE_CAR: PipeSpec = {
  colStart: 40,
  phases: [
    {
      name: 'Entrada',
      fields: [
        { key: 'municipio', label: 'Município', type: 'text' },
        { key: 'area_estimada_ha', label: 'Área estimada (ha)', type: 'number' },
        { key: 'data_entrada', label: 'Data de entrada', type: 'date' },
      ],
    },
    {
      name: 'Documentação + Levantamento de Campo',
      fields: [
        { key: 'shape_url', label: 'URL do shapefile', type: 'text' },
      ],
    },
    {
      name: 'Mapeamento / Inscrição SICAR',
      fields: [
        { key: 'shape_url', label: 'URL do shape/planta', type: 'text' },
        { key: 'numero_protocolo', label: 'Nº protocolo SICAR', type: 'text' },
        { key: 'data_protocolo', label: 'Data protocolo', type: 'date' },
      ],
    },
    {
      name: 'Análise SEDAM',
      fields: [
        { key: 'status_sicar', label: 'Status SICAR', type: 'select', options: STATUS_SICAR },
        { key: 'retificacao', label: 'Retificação', type: 'select', options: STATUS_RETIFICACAO },
        { key: 'pedido_analise_prioritaria', label: 'Pedido de análise prioritária', type: 'select', options: SIM_NAO },
        { key: 'motivo_analise_prioritaria', label: 'Motivo da prioridade', type: 'select', options: MOTIVO_PRIORIDADE_CAR, showIf: (c) => c.pedido_analise_prioritaria === 'sim' },
        { key: 'documento_prioridade_anexado', label: 'Documento oficial anexado', type: 'select', options: SIM_NAO, showIf: (c) => c.pedido_analise_prioritaria === 'sim' },
        { key: 'tipo_documento_prioridade', label: 'Tipo do documento de prioridade', helpText: 'Informe o nome do documento que fundamenta a prioridade, como declaração, ofício ou documento bancário comprobatório.', type: 'text', showIf: (c) => c.pedido_analise_prioritaria === 'sim' },
        { key: 'numero_documento_prioridade', label: 'Nº do Ofício para Protocolo', helpText: 'Informe o número do ofício ou do documento que será usado no protocolo, se existir. Se o documento não tiver numeração, registre s/n ou siga o padrão interno adotado.', type: 'text', showIf: (c) => c.pedido_analise_prioritaria === 'sim' },
        { key: 'protocolo_analise_prioritaria', label: 'Protocolo SEI', helpText: 'Informe o número do processo ou protocolo SEI gerado para acompanhar o pedido de análise prioritária.', type: 'text', showIf: (c) => c.pedido_analise_prioritaria === 'sim' },
        { key: 'data_protocolo_analise_prioritaria', label: 'Data do protocolo da prioridade', helpText: 'Preencha com a data em que o requerimento de prioridade foi protocolado no SEI.', type: 'date', showIf: (c) => c.pedido_analise_prioritaria === 'sim' },
        { key: 'observacao_prioridade', label: 'Observações da prioridade', helpText: 'Use este campo para registrar detalhes úteis ao acompanhamento, como fundamento do pedido, situação do envio ou pendências documentais.', type: 'textarea', showIf: (c) => c.pedido_analise_prioritaria === 'sim' },
        { key: 'pedido_analise_prioritaria', label: 'Formulário da prioridade', type: 'emitir_formulario_prioridade', editable: false, showIf: (c) => c.pedido_analise_prioritaria === 'sim' },
      ],
    },
    {
      name: 'Pendente de Retificação',
      fields: [
        { key: 'ultima_data_notificacao', label: 'Última data da notificação', type: 'date' },
        { key: 'ultimo_numero_notificacao', label: 'Último número da notificação', type: 'text' },
        { key: 'possui_retificacao_aberta', label: 'Possui retificação aberta', type: 'select', options: SIM_NAO },
      ],
    },
    {
      name: 'Aprovado com Pendência',
      fields: [
        { key: 'status_final_analise_car', label: 'Status final do CAR', type: 'select', options: STATUS_FINAL_CAR },
        { key: 'codigo_car', label: 'Código CAR', type: 'text' },
        { key: 'data_inscricao_car', label: 'Data inscrição CAR', type: 'date' },
        { key: 'observacoes_finais', label: 'Observações finais', type: 'textarea' },
      ],
    },
    {
      name: 'Aprovado sem Pendência',
      fields: [
        { key: 'status_final_analise_car', label: 'Status final do CAR', type: 'select', options: STATUS_FINAL_CAR },
        { key: 'codigo_car', label: 'Código CAR', type: 'text' },
        { key: 'data_inscricao_car', label: 'Data inscrição CAR', type: 'date' },
        { key: 'observacoes_finais', label: 'Observações finais', type: 'textarea' },
      ],
    },
  ],
};

const PIPE_CAR_RETIFICACAO: PipeSpec = {
  colStart: 47,
  phases: [
    { name: 'Caixa de Entrada', fields: [
      { key: 'data_notificacao', label: 'Data da notificação', type: 'date' },
      { key: 'numero_notificacao', label: 'Número da notificação', type: 'text' },
      { key: 'notificacao_anexada', label: 'Notificação anexada', type: 'select', options: SIM_NAO },
      { key: 'arquivo_notificacao', label: 'Arquivo da notificação', type: 'text' },
    ]},
    { name: 'Diagnóstico da Retificação', fields: [
      { key: 'descricao_exigencia', label: 'Descrição da exigência', type: 'textarea' },
      { key: 'tipo_ajuste', label: 'Tipo de ajuste', type: 'select', options: TIPO_AJUSTE_RETIFICACAO },
    ]},
    { name: 'Lançamento em Software (CAR/PRA)', fields: [
      { key: 'observacoes', label: 'Observações do lançamento', type: 'textarea' },
    ]},
    { name: 'Validação das Informações em Software (CAR/PRA)', fields: [
      { key: 'observacoes', label: 'Observações da validação', type: 'textarea' },
    ]},
    { name: 'Transmitido/Enviado', fields: [
      { key: 'data_reenvio', label: 'Data do reenvio', type: 'date' },
      { key: 'protocolo_reenvio', label: 'Protocolo de reenvio', type: 'text' },
      { key: 'resultado_apos_analise', label: 'Resultado após análise', type: 'select', options: RESULTADO_RETIFICACAO },
      { key: 'observacoes_finais', label: 'Observações finais', type: 'textarea' },
    ]},
  ],
};

const PIPE_DESEMBARGO: PipeSpec = {
  colStart: 52,
  phases: [
    {
      name: 'Entrada',
      fields: [
        { key: 'municipio', label: 'Município', type: 'text' },
        { key: 'data_entrada', label: 'Data de entrada', type: 'date' },
      ],
    },
    {
      name: 'Documentação',
      fields: [],
    },
    {
      name: 'Análise do auto/embargo',
      fields: [
        { key: 'auto_infracao_numero', label: 'Nº auto de infração', type: 'text' },
        { key: 'termo_embargo_numero', label: 'Nº termo de embargo', type: 'text' },
        { key: 'area_embargada_ha', label: 'Área embargada (ha)', type: 'number' },
        { key: 'processo_administrativo', label: 'Nº processo administrativo', type: 'text' },
      ],
    },
    {
      name: 'Defesa técnica / laudo',
      fields: [
        { key: 'art_numero', label: 'Nº ART (defesa)', type: 'text' },
        { key: 'observacoes', label: 'Anotações da defesa', type: 'textarea' },
      ],
    },
    {
      name: 'Protocolo',
      fields: [
        { key: 'numero_protocolo', label: 'Nº protocolo', type: 'text' },
        { key: 'data_protocolo', label: 'Data protocolo', type: 'date' },
        { key: 'orgao_competente', label: 'Órgão competente (SEDAM/IBAMA)', type: 'text' },
      ],
    },
    {
      name: 'Análise do órgão',
      fields: [
        { key: 'observacoes', label: 'Observações da análise', type: 'textarea' },
      ],
    },
    {
      name: 'Vistoria',
      // data_vistoria_incra / observacoes_campo não existem em ambiental.
      fields: [],
    },
    {
      name: 'Concluído',
      fields: [
        { key: 'observacoes_finais', label: 'Observações finais', type: 'textarea' },
      ],
    },
  ],
};

const PIPE_LIMPEZA: PipeSpec = {
  colStart: 60,
  phases: [
    {
      name: 'Entrada',
      fields: [
        { key: 'municipio', label: 'Município', type: 'text' },
        { key: 'area_limpeza_ha', label: 'Área de limpeza (ha)', type: 'number' },
        { key: 'data_entrada', label: 'Data de entrada', type: 'date' },
      ],
    },
    {
      name: 'Documentação',
      fields: [],
    },
    {
      name: 'Projeto técnico / ART',
      fields: [
        { key: 'art_numero', label: 'Nº ART', type: 'text' },
        { key: 'art_valor', label: 'Valor ART (R$)', type: 'number' },
      ],
    },
    {
      name: 'Mapa e Shape',
      fields: [
        { key: 'shape_url', label: 'URL do shape/planta', type: 'text' },
      ],
    },
    {
      name: 'Protocolo SEDAM',
      fields: [
        { key: 'numero_protocolo', label: 'Nº protocolo', type: 'text' },
        { key: 'data_protocolo', label: 'Data protocolo', type: 'date' },
      ],
    },
    {
      name: 'Análise',
      fields: [
        { key: 'observacoes', label: 'Observações da análise', type: 'textarea' },
      ],
    },
    {
      name: 'Concluído',
      fields: [
        { key: 'numero_licenca', label: 'Nº autorização', type: 'text' },
        { key: 'data_emissao_licenca', label: 'Data emissão', type: 'date' },
        { key: 'observacoes_finais', label: 'Observações finais', type: 'textarea' },
      ],
    },
  ],
};

// LP / LI / LO compartilham estrutura — diferem só no rótulo da última fase.
function pipeLicenca(colStart: number, ultimaFase: string): PipeSpec {
  return {
    colStart,
    phases: [
      {
        name: 'Entrada',
        fields: [
          { key: 'atividade', label: 'Atividade', type: 'text' },
          { key: 'municipio', label: 'Município', type: 'text' },
          { key: 'data_entrada', label: 'Data de entrada', type: 'date' },
        ],
      },
      {
        name: 'Documentação',
        fields: [],
      },
      {
        name: colStart === 70 ? 'RCA' : colStart === 80 ? 'Projetos técnicos + ART' : 'AVCIP bombeiros',
        fields: [
          { key: 'art_numero', label: 'Nº ART', type: 'text' },
          { key: 'art_valor', label: 'Valor ART (R$)', type: 'number' },
          { key: 'observacoes', label: 'Observações', type: 'textarea' },
        ],
      },
      {
        name: colStart === 70 ? 'Publicação em jornal' : colStart === 80 ? 'PCA / Estudos' : 'Relatório de conformidade',
        fields: [
          { key: 'observacoes', label: 'Observações', type: 'textarea' },
        ],
      },
      {
        name: 'Protocolo prefeitura',
        fields: [
          { key: 'numero_protocolo', label: 'Nº protocolo', type: 'text' },
          { key: 'data_protocolo', label: 'Data protocolo', type: 'date' },
          { key: 'orgao_competente', label: 'Órgão competente', type: 'text' },
        ],
      },
      {
        name: 'Análise',
        fields: [
          { key: 'observacoes', label: 'Observações da análise', type: 'textarea' },
        ],
      },
      {
        name: 'Vistoria',
        // data_vistoria_incra / observacoes_campo são do GEO. Sem coluna em ambiental.
        fields: [],
      },
      {
        name: ultimaFase,
        fields: [
          { key: 'numero_licenca', label: 'Nº licença', type: 'text' },
          { key: 'data_emissao_licenca', label: 'Data emissão', type: 'date' },
          { key: 'data_validade_licenca', label: 'Data validade', type: 'date' },
          { key: 'observacoes_finais', label: 'Observações finais', type: 'textarea' },
        ],
      },
    ],
  };
}

const PIPE_LP = pipeLicenca(70, 'LP emitida');
const PIPE_LI = pipeLicenca(80, 'LI emitida');
const PIPE_LO = pipeLicenca(90, 'LO emitida');
const PIPE_LAUDO_PARECER: PipeSpec = {
  colStart: 110,
  phases: [
    {
      name: 'Entrada',
      fields: [
        { key: 'municipio', label: 'Município', type: 'text' },
        { key: 'data_entrada', label: 'Data de entrada', type: 'date' },
        { key: 'observacoes', label: 'Contexto inicial', type: 'textarea' },
      ],
    },
    {
      name: 'Documentação',
      fields: [],
    },
    {
      name: 'Produção',
      fields: [
        { key: 'art_numero', label: 'Nº ART', type: 'text' },
        { key: 'observacoes', label: 'Andamento técnico', type: 'textarea' },
      ],
    },
    {
      name: 'Revisão',
      fields: [
        { key: 'observacoes', label: 'Pontos de revisão', type: 'textarea' },
      ],
    },
    {
      name: 'Entrega',
      fields: [
        { key: 'observacoes_finais', label: 'Registro da entrega', type: 'textarea' },
      ],
    },
    {
      name: 'Acompanhamento',
      fields: [
        { key: 'observacoes_finais', label: 'Retornos e ajustes', type: 'textarea' },
      ],
    },
    {
      name: 'Concluído',
      fields: [
        { key: 'observacoes_finais', label: 'Observações finais', type: 'textarea' },
      ],
    },
  ],
};
const PIPE_ANALISE_MULTITEMPORAL: PipeSpec = {
  colStart: 120,
  phases: [
    {
      name: 'Entrada',
      fields: [
        { key: 'municipio', label: 'Município', type: 'text' },
        { key: 'data_entrada', label: 'Data de entrada', type: 'date' },
        { key: 'observacoes', label: 'Escopo da análise', type: 'textarea' },
      ],
    },
    {
      name: 'Documentação',
      fields: [],
    },
    {
      name: 'Produção',
      fields: [
        { key: 'observacoes', label: 'Achados técnicos', type: 'textarea' },
      ],
    },
    {
      name: 'Revisão',
      fields: [
        { key: 'observacoes', label: 'Pontos de revisão', type: 'textarea' },
      ],
    },
    {
      name: 'Entrega',
      fields: [
        { key: 'observacoes_finais', label: 'Registro da entrega', type: 'textarea' },
      ],
    },
    {
      name: 'Acompanhamento',
      fields: [
        { key: 'observacoes_finais', label: 'Retornos e ajustes', type: 'textarea' },
      ],
    },
    {
      name: 'Concluído',
      fields: [
        { key: 'observacoes_finais', label: 'Observações finais', type: 'textarea' },
      ],
    },
  ],
};
const PIPE_TRIAGEM: PipeSpec = {
  colStart: 100,
  phases: [
    {
      name: 'Triagem',
      fields: [
        { key: 'servico_tipo', label: 'Serviço pretendido', type: 'select', options: SERVICO_TIPO },
        { key: 'licenciamento_etapa', label: 'Etapa do licenciamento', type: 'select', options: LICENCIAMENTO_ETAPA },
        { key: 'estudo_tecnico_tipo', label: 'Subtipo técnico', type: 'select', options: ESTUDO_TECNICO_TIPO },
        { key: 'municipio', label: 'Município', type: 'text' },
        { key: 'observacoes', label: 'Levantamento superficial', type: 'textarea' },
      ],
    },
    {
      name: 'Negociação',
      fields: [
        { key: 'status_negociacao', label: 'Status da negociação', type: 'select', options: STATUS_NEGOCIACAO },
        { key: 'cliente_cpf', label: 'Orçamento', type: 'emitir_orcamento', editable: false },
        { key: 'observacoes_finais', label: 'Observações comerciais', type: 'textarea' },
      ],
    },
    {
      name: 'Encaminhado',
      fields: [
        { key: 'card_filho_id', label: 'Card filho gerado', type: 'text' },
      ],
    },
  ],
};

function pickPipe(c: Record<string, unknown>): PipeSpec | null {
  const tipo = String(c.tipo_processo ?? '').toLowerCase();
  if (tipo === 'triagem_ambiental') return PIPE_TRIAGEM;
  if (tipo === 'ambiental_pra') return PIPE_PRA;
  if (tipo === 'ambiental_car') return PIPE_CAR;
  if (tipo === 'ambiental_car_retificacao') return PIPE_CAR_RETIFICACAO;
  if (tipo === 'ambiental_desembargo') return PIPE_DESEMBARGO;
  if (tipo === 'ambiental_limpeza') return PIPE_LIMPEZA;
  if (tipo === 'ambiental_lp') return PIPE_LP;
  if (tipo === 'ambiental_li') return PIPE_LI;
  if (tipo === 'ambiental_lo') return PIPE_LO;
  if (tipo === 'ambiental_laudo_parecer') return PIPE_LAUDO_PARECER;
  if (tipo === 'ambiental_analise_multitemporal') return PIPE_ANALISE_MULTITEMPORAL;
  // Fallback por kanban_coluna
  const col = Number(c.kanban_coluna);
  if (Number.isFinite(col)) {
    if (col >= 100 && col <= 102) return PIPE_TRIAGEM;
    if (col >= 30 && col <= 37) return PIPE_PRA;
    if (col >= 40 && col <= 46) return PIPE_CAR;
    if (col >= 47 && col <= 51) return PIPE_CAR_RETIFICACAO;
    if (col >= 52 && col <= 59) return PIPE_DESEMBARGO;
    if (col >= 60 && col <= 66) return PIPE_LIMPEZA;
    if (col >= 70 && col <= 77) return PIPE_LP;
    if (col >= 80 && col <= 87) return PIPE_LI;
    if (col >= 90 && col <= 97) return PIPE_LO;
    if (col >= 110 && col <= 116) return PIPE_LAUDO_PARECER;
    if (col >= 120 && col <= 126) return PIPE_ANALISE_MULTITEMPORAL;
  }
  return null;
}

export const ambientalCardFieldMap: CardFieldMap = (card) => {
  const cliente = String(card.cliente_nome ?? '—');
  const grupoEconomico = String(card.grupo_economico_nome ?? '').trim();
  const isPj = String(card.grupo_economico_cnpj ?? '').replace(/\D/g, '').length > 0;
  const tituloPrincipal = isPj && grupoEconomico ? grupoEconomico : cliente;
  const apoioRequerente = isPj && grupoEconomico && cliente && cliente !== grupoEconomico
    ? cliente
    : null;
  const protocolo = card.numero_protocolo ? String(card.numero_protocolo) : null;
  const orgao = card.orgao_competente ? String(card.orgao_competente) : null;
  const statusRaw = card.status ? String(card.status) : null;
  const statusVal = statusLabel(statusRaw);
  const servicoLabel = resolveServicoLabel(card);
  const isRetificacaoChild = !!card.processo_car_pai_id;
  const isCar = String(card.tipo_processo || '').trim() === 'ambiental_car';
  const isCarRetificacao = String(card.tipo_processo || '').trim() === 'ambiental_car_retificacao';

  if (isCar) {
    return {
      title: tituloPrincipal,
      subtitle: apoioRequerente || resolveCarSubtitle(card),
      chips: buildCarChips(card),
      meta: buildCarMeta(card),
    };
  }

  if (isCarRetificacao) {
    return {
      title: tituloPrincipal,
      subtitle: apoioRequerente || resolveCarSubtitle(card),
      chips: buildCarRetificacaoChildChips(card),
      meta: buildCarMeta(card),
    };
  }

  return {
    title: tituloPrincipal,
    subtitle: apoioRequerente || servicoLabel
      || (card.imovel_matricula
        ? `Matrícula ${String(card.imovel_matricula)}`
        : (card.imovel_denominacao ? String(card.imovel_denominacao) : null)),
    chips: [
      isRetificacaoChild ? { label: 'Rodada', value: `Retificação`, tone: 'warn' } : null,
      { label: '', value: statusVal, tone: statusTone(statusRaw) },
      { label: 'Serviço', value: servicoLabel, tone: 'accent' },
      { label: 'Protocolo', value: protocolo, tone: 'info' },
      { label: 'Órgão', value: orgao, tone: 'neutral' },
    ].filter(Boolean) as CardSlot[],
    meta: card.municipio ? String(card.municipio) : null,
  };
};

export const ambientalDetailFieldMap: DetailFieldMap = (card) => {
  const c = card as Record<string, unknown>;
  const out: ReturnType<DetailFieldMap> = [];
  out.push(...buildDadosPrincipais(c));
  if (isCarEntrada(c)) {
    out.push(...buildCarFormularioFields(c));
  }
  if (c.processo_car_pai_id || c.qtd_retificacoes || c.retificacao) {
    if (c.processo_car_pai_id) {
      out.push({ section: 'Controle de retificação', label: 'Processo CAR pai', value: asStr(c.processo_car_pai_id), alwaysShow: true });
    }
    if (c.rodada_retificacao) {
      out.push({ section: 'Controle de retificação', label: 'Rodada da retificação', value: asStr(c.rodada_retificacao), alwaysShow: true });
    }
    if (!c.processo_car_pai_id && c.qtd_retificacoes) {
      out.push({ section: 'Controle de retificação', label: 'Qtd. de retificações', value: asStr(c.qtd_retificacoes), alwaysShow: true });
    }
    if (c.retificacao) {
      out.push({ section: 'Controle de retificação', label: 'Status da retificação', value: findLabel(STATUS_RETIFICACAO, c.retificacao) || asStr(c.retificacao), alwaysShow: true });
    }
  }
  const pipe = pickPipe(c);
  if (pipe) {
    out.push(...buildPhases(c, pipe));
  }
  out.push(...buildObservacoes(c));
  // O drawer ambiental usa abas. Sem vincular os campos à aba Cadastro,
  // todos são filtrados e o card exibe apenas "Sem campos adicionais".
  return out.map((field) => ({
    ...field,
    tab: field.tab ?? 'cadastro',
  }));
};
